import { createApp } from "vue";
import { createPinia } from "pinia";
import VueSmoothScroll from "vue3-smooth-scroll";

import App from "./App";

import "~/assets/styles/main.scss";

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(VueSmoothScroll, {
    updateHistory: false,
});
app.mount("#header-menu");
